// Reglas puras de Secciones del menú (orden y nombre); `node --test`.
// Doc: _docs/frontend/catalog_presentation/partner_sections.md

// Nuevo orden al mover `id` un lugar (delta -1 sube, 1 baja); en el borde devuelve la misma lista
export function moveId(ids, id, delta) {
  const from = ids.indexOf(id)
  const to = from + delta
  if (from < 0 || to < 0 || to >= ids.length) return ids
  const next = ids.slice()
  next.splice(from, 1)
  next.splice(to, 0, id)
  return next
}

// Orden conocido tras un cambio del DOM por stream; con un envío pendiente no adopta el orden optimista
export function reconcileOrder(saved, current, pending) {
  if (!pending) return current
  return saved.filter(id => current.includes(id)).concat(current.filter(id => !saved.includes(id)))
}

export function movedLabel(position) {
  return `Movida al lugar ${position}`
}

// Clave de comparación de nombres, igual que Section.comparable_name: sin acentos, mayúsculas ni espacios de más
export function nameKey(value) {
  return String(value ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ")
}

export const NAME_ERRORS = {
  blank: "Escribe un nombre para la sección.",
  taken: "Ya existe una sección con ese nombre."
}

// Lo que el servidor rechazaría: null si sirve, si no el mensaje; `except` es el propio al renombrar
export function nameError(value, names, except = null) {
  const key = nameKey(value)
  if (!key) return NAME_ERRORS.blank
  const own = nameKey(except)
  if (names.some(existing => nameKey(existing) === key && nameKey(existing) !== own)) return NAME_ERRORS.taken
  return null
}
